export default __webpack_public_path__ + "static/media/main.c3ade863.jpg";